export const formatCalculationDate = (date: Date, locale = 'fi-FI'): string =>
  new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
